module.exports = __webpack_public_path__ + "img/approach.6acd985.svg";